export function formatReviewName(name: string): string {
  let cleanedName = name.replace(/[-_]/g, ' ')
  cleanedName = cleanedName.replace(/\.([^.]{3,4})$/, '')
  return cleanedName
}
